import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIbeaconComponent } from './simple-icons-ibeacon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIbeaconComponent ],
    exports:      [ SimpleIconsIbeaconComponent ],
    bootstrap:    []
})
export class SimpleIconsIbeaconModule {}
